//@ts-strict-ignore
import hasValidationErrors from '../../components/connectedForm/utils/hasValidationErrors';
import { createBackgroundJob } from '../../utils/BackgroundJobs';
import { getMutationProps, getRangeMutationProps } from '../sales/DocumentAction';
import SalesCredit from '../../graphql/entities/salesLedger/SalesCredit';
import { onDocumentComplete, onDocumentPrintFailed } from '../../utils/DocumentUtils';
import { DocumentNode } from '@apollo/client';

function onComplete(state, props, job) {
  const { overrideOutput, outputType, showSummary } = state;
  const { dispatch, onClose, onProcessSummary, onComplete, onProcessPreview } = props;

  onDocumentComplete({
    overrideOutput,
    outputType,
    documentName: 'Sales Credit',
    documentNamePlural: 'Sales Credits',
    dispatch,
    onClose: () => onClose(false, state, props, job),
    showSummary,
    onProcessSummary: () => onProcessSummary(false, state, props, job),
    onProcessPreview,
    job,
    onComplete,
  });
}

export function generate(state, props, variables, returnUrl) {
  if (hasValidationErrors(props)) return;
  createBackgroundJob(
    SalesCredit.generate as DocumentNode,
    getMutationProps(state, props, variables, 'salesCredit'),
    props,
    returnUrl,
    'Print Sales Credit',
    (job) => onComplete(state, props, job)
  );
}

export function generateRange(state, props, variables, returnUrl, { rangeMutationProps }) {
  if (hasValidationErrors(props)) return;
  createBackgroundJob(
    SalesCredit.generateRange as DocumentNode,
    rangeMutationProps || getRangeMutationProps(state, props, variables, 'salesCredits', 'Customers/Credit/Workspace'),
    props,
    returnUrl,
    'Generate Sales Credit Document',
    (job) => onComplete(state, props, job),
    (job) => onDocumentPrintFailed(state, props, job)
  );
}

export const printFunctions = {
  generate,
  generateRange,
};
